const KEY = "stb_open_chats";

function emit() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("stb-chats-changed"));
  }
}

export function listOpenChats() {
  if (typeof sessionStorage === "undefined") return [];
  try {
    const raw = JSON.parse(sessionStorage.getItem(KEY) || "[]");
    return Array.isArray(raw) ? raw : [];
  } catch {
    return [];
  }
}

export function rememberOpenChat(session) {
  if (!session?.roomId || !session?.token) return;
  const next = [
    {
      roomId: session.roomId,
      token: session.token,
      listingTitle: session.listingTitle || "",
      listingId: session.listingId || "",
      otherName: session.otherName || "Chat",
    },
    ...listOpenChats().filter((c) => c.roomId !== session.roomId),
  ].slice(0, 3);
  sessionStorage.setItem(KEY, JSON.stringify(next));
  emit();
}

export function forgetOpenChat(roomId) {
  sessionStorage.setItem(
    KEY,
    JSON.stringify(listOpenChats().filter((c) => c.roomId !== roomId)),
  );
  emit();
}
